import {useEffect} from 'react';
import ReactGA from 'react-ga4';
import './app.scss';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar, Container } from 'react-bootstrap';
import Main from './Main';
import Catholic from './Catholic';

function App() {

  useEffect(() => {
    if (process.env.NODE_ENV === 'production') {
      ReactGA.initialize('G-W5JQEJKKYE');
      ReactGA.send({ hitType: "pageview", page: window.location.pathname });
    }
  }, []);

  let title = "";
  title = window.location.pathname.toLowerCase() !== "/catholic" ? "JOHN BEAGAN" : "Encouraging the Faith";

  return (
    <>
      <Container className="main-container">
        <Navbar collapseOnSelect fixed='top' expand='sm' bg='light' variant='light' >
          <Navbar.Brand style={{ marginLeft: "2rem" }} href="/">{title}</Navbar.Brand>
        </Navbar>
        <BrowserRouter>
          <Routes>
            <Route path="/catholic" element={<Catholic />} />
            <Route path="/" element={<Main />} />
            <Route path="*" element={<Main />} />
          </Routes>
        </BrowserRouter>
      </Container>
    </>
  );
}

export default App;


